import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { AdminSessionsListPage } from '@/components/profile/admin-sessions-list-page';

export default function SessionsPage() {
    return (
        <ProtectedRoute>
            <MainLayout>
                <AdminSessionsListPage />
            </MainLayout>
        </ProtectedRoute>
    );
}
